import './copyRight.css';

export default function CopyRight() {

  return (
    <>
        <p className='copyright'>
            &copy; 2025 Moe Kamimoto
        </p>
    </>
  );
}
